import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0478fc40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap claim-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "BU", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_4 = { class: "ag-table" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" // loading加载 ")
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 4 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_v_nodes = _resolveComponent("v-nodes")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_DrawerUpload = _resolveComponent("DrawerUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, {
        class: "feature-con",
        align: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_2,
                _createVNode(_component_a_select, {
                  value: _ctx.buSelected,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buSelected) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size",
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.orgid,
                        key: item.orgid
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.orgnmen), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              (_ctx.$btnPermissions('SEARCH'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "s-w btn-style",
                    type: "primary",
                    onClick: _ctx.getTableData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_space, { class: "table-button flex-div justify-e" }, {
          default: _withCtx(() => [
            (_ctx.$btnPermissions('SAVE'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.handleSave
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_a_table, {
            pagination: false,
            scroll: { y: _ctx.tableHeight - 380, x: 1000 },
            rowKey: (item, index) => index,
            class: "modle-header self-table-input",
            rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
            columns: _ctx.columns,
            "data-source": _ctx.tableData
          }, _createSlots({
            action: _withCtx(({ record, index }) => [
              (_ctx.$btnPermissions('UPLOAD'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.handleUpload(record, index)),
                    class: "cursor-p m-l-10"
                  }, "Upload", 8, _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('DOWNLOAD'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.handleDownload(record.id)),
                    class: "cursor-p m-l-10"
                  }, "Download", 8, _hoisted_13))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('DELETE'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    onClick: ($event: any) => (_ctx.handleDelete(record.id)),
                    class: "cursor-p m-l-10"
                  }, "Delete", 8, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            _renderList(_ctx.tableCol, (col) => {
              return {
                name: col.id,
                fn: _withCtx(({ record }) => [
                  (col.id === 'bu')
                    ? (_openBlock(), _createBlock(_component_a_select, {
                        key: 0,
                        value: record[col.id],
                        "onUpdate:value": ($event: any) => ((record[col.id]) = $event),
                        onFocus: ($event: any) => (_ctx.handleFocus(col.id, record)),
                        style: {"width":"150px"},
                        "label-in-value": "",
                        options: _ctx.buOption
                      }, null, 8, ["value", "onUpdate:value", "onFocus", "options"]))
                    : _createCommentVNode("", true),
                  (col.id === 'incentiveCategory')
                    ? (_openBlock(), _createBlock(_component_a_select, {
                        key: 1,
                        value: record[col.id],
                        "onUpdate:value": ($event: any) => ((record[col.id]) = $event),
                        style: {"width":"180px"},
                        onFocus: ($event: any) => (_ctx.handleFocus(col.id, record)),
                        onChange: ($event: any) => (_ctx.handleChange(col.id, record)),
                        "not-found-content": _ctx.fetching ? undefined : 'No Data'
                      }, _createSlots({
                        default: _withCtx(() => [
                          _hoisted_6,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableCellSelect, (ite) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: ite.id,
                              value: ite.nameEn,
                              title: ite.nameEn
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(ite.nameEn), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "title"]))
                          }), 128))
                        ]),
                        _: 2
                      }, [
                        (_ctx.fetching)
                          ? {
                              name: "notFoundContent",
                              fn: _withCtx(() => [
                                _createVNode(_component_a_spin, { size: "small" })
                              ])
                            }
                          : undefined
                      ]), 1032, ["value", "onUpdate:value", "onFocus", "onChange", "not-found-content"]))
                    : _createCommentVNode("", true),
                  (col.id === 'offerType')
                    ? (_openBlock(), _createBlock(_component_a_select, {
                        key: 2,
                        value: record[col.id],
                        "onUpdate:value": ($event: any) => ((record[col.id]) = $event),
                        mode: "multiple",
                        style: {"width":"180px"},
                        onFocus: ($event: any) => (_ctx.handleFocus(col.id, record)),
                        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checked = false)),
                        onChange: ($event: any) => (_ctx.hanleChangeOfferType(col.id, record)),
                        "not-found-content": _ctx.fetching ? undefined : 'No Data'
                      }, _createSlots({
                        dropdownRender: _withCtx(({ menuNode: menu }) => [
                          _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
                          _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
                          _createElementVNode("div", {
                            onMousedown: _cache[1] || (_cache[1] = e => e.preventDefault()),
                            class: "all-check",
                            onClick: ($event: any) => (_ctx.handleAllCheck(col.id, record))
                          }, _toDisplayString(_ctx.checked ? '取消全选' : '全选'), 41, _hoisted_7)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableCellSelectOffer, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item.nameEn,
                              key: item.id,
                              "item.nameEn": ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nameEn), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, [
                        (_ctx.fetching)
                          ? {
                              name: "notFoundContent",
                              fn: _withCtx(() => [
                                _createVNode(_component_a_spin, { size: "small" })
                              ])
                            }
                          : undefined
                      ]), 1032, ["value", "onUpdate:value", "onFocus", "onChange", "not-found-content"]))
                    : _createCommentVNode("", true),
                  (col.type === 'TEXT')
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 3,
                        style: {"width":"180px"},
                        value: record[col.id],
                        "onUpdate:value": ($event: any) => ((record[col.id]) = $event)
                      }, null, 8, ["value", "onUpdate:value"]))
                    : _createCommentVNode("", true),
                  (col.type === 'CHECK')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["font_family f20", record[col.id] === 'true' ? 'icon-icon-test color-blue' : 'icon-fuxuankuang']),
                          onClick: ($event: any) => (record[col.id] = record[col.id] === 'true' ? 'false' : 'true')
                        }, null, 10, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  (col.type === 'CHECK_BOX')
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 5,
                        checked: record[col.id],
                        "onUpdate:checked": ($event: any) => ((record[col.id]) = $event)
                      }, null, 8, ["checked", "onUpdate:checked"]))
                    : _createCommentVNode("", true),
                  (col.type === 'INTEGER')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record[col.id]), 1))
                    : _createCommentVNode("", true),
                  (col.id === 'Operation')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Delete"))
                    : _createCommentVNode("", true)
                ])
              }
            })
          ]), 1032, ["scroll", "rowKey", "rowClassName", "columns", "data-source"])
        ])
      ]),
      _createVNode(_component_DrawerUpload, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
        url: _ctx.importAttachment,
        title: 'Upload Attachement',
        data: _ctx.rowData,
        index: _ctx.currentIndex,
        onUpdateTable: _ctx.updateTable
      }, null, 8, ["visible", "url", "data", "index", "onUpdateTable"])
    ])
  ], 64))
}